/**
 * 注册相关API
 * */

import request from '@/utils/request'
import { SERVER_URL } from '@/config'
import { request as http } from '@/utils/request'

const gateWay = '/permission'

export function apiRegister(data) {
    // 注册 - 完成
    return http({
        url: gateWay + '/register/save/v2',
        method: 'post',
        data,
    })
}

export const apiGetCaptcha = {
    // 获取图形验证码
    url: SERVER_URL + gateWay + '/register/captcha',
}

export function apiCaptchaValidate(data) {
    // 校验图形验证码
    return request({
        url: gateWay + '/register/captchaValidate',
        method: 'post',
        data,
    })
}

export function apiValidateEmail(data) {
    // 验证邮箱是否验证过
    return http({
        url: gateWay + '/register/validateEmail/v2',
        method: 'post',
        data,
    })
}

/**
 * 激活账号
 * type:  0:主账号激活， 1:子账号激活， 2:找回密码
 * 参数: {"key": "8a07dbff19ed9ebe44b8b13d5e738c9fefb3a7d7ed4f4a6bcac9e80e5329fc8d", "type": "0"} //tye ==> 0:主账号激活， 1:子账号激活， 2:找回密码
 * */
export function apiActivateUserAccount(data) {
    //激活账号
    return request({
        url: gateWay + '/activate/activateUser',
        method: 'post',
        data,
    })
}

/* 中国省份列表 */
export function apiGetProvinceList() {
    return http({
        url: gateWay + '/register/selectProvince',
        method: 'post',
    })
}

/* 发送手机验证码短信 */
export function apiSendSmsCaptcha(data) {
    return http({
        url: gateWay + '/register/sendMessage',
        method: 'post',
        data,
    })
}

/* 校验手机号是否已被占用 */
export function apiValidatePhone(data) {
    return http({
        url: gateWay + '/register/validatePhone',
        method: 'post',
        data,
    })
}
